export default __webpack_public_path__ + "static/media/software.f4b8f0f9.png";